import { render, staticRenderFns } from "./ModuleIframe.vue?vue&type=template&id=3c2e7e5f"
import script from "./ModuleIframe.vue?vue&type=script&lang=js"
export * from "./ModuleIframe.vue?vue&type=script&lang=js"
import style0 from "./ModuleIframe.vue?vue&type=style&index=0&id=3c2e7e5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports